import { urlFor } from '../../../sanity/lib/image';
import styles from './Features.module.scss';
import InlineSVG from "@/components/InlineSVG";
import { IconRenderer } from "@/components/IconRenderer";

export function Features({ features }) {
	return (
		<div className={styles.features}>
			{features.map((feature, i) => (
				<div className={styles.feature} key={`feature-${i}`}>
					{feature.mediaType === "icon" && feature.icon && (
						<div className={styles.featureIcon}>
							<IconRenderer icon={feature.icon} className={styles.icon} />
						</div>
					)}

					{feature.mediaType === "image" && feature.image?.asset && (
						<div className={styles.featureIcon}>
							<InlineSVG url={urlFor(feature.image.asset).url()} />
						</div>
					)}

					<div className={styles.featureText}>
						<h3>{feature.title}</h3>
						<p>{feature.text}</p>
					</div>
				</div>
			))}
		</div>
	);
}
